import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { mensajeAmigable } from '../utils/errores';
import { obtenerOrdenes, cambiarEstadoOrden, eliminarOrden } from '../services/ordenesService';
import { obtenerClientes } from '../services/clientesService';
import { linkWhatsAppA } from '../utils/compartir';
import { ESTADOS_ORDEN, estadoOrdenInfo } from '../utils/ordenes';
import OrdenForm from './OrdenForm';

const P = 'var(--color-primario,#DB2777)';

export default function OrdenesView({ onVolver }) {
  const { negocio } = useAuth();
  const { mostrarToast } = useToast();
  const { puede } = useAuth();
  const esVendedora = !puede('borrar'); // sin permiso "Borrar registros" (también lo bloquea la BD)
  const [ordenes, setOrdenes] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [error, setError] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [form, setForm] = useState(null); // null | { orden? }

  const cargar = async () => {
    setError(null);
    try { setOrdenes(await obtenerOrdenes()); }
    catch (e) { setError(mensajeAmigable(e)); }
  };
  useEffect(() => { cargar(); obtenerClientes().then(setClientes).catch(() => {}); }, []);

  // Avisa al cliente por WhatsApp según el estado de su orden (abre el borrador).
  const avisar = (o) => {
    const cli = clientes.find((x) => x.id === o.cliente_id);
    const tel = cli?.telefono || '';
    const nombre = (o.cliente_nombre || '').trim().split(' ')[0] || '';
    const saludo = nombre ? `Hola ${nombre}! 👋` : '¡Hola! 👋';
    const serv = o.servicio_nombre ? `*${o.servicio_nombre}*` : 'tu servicio';
    const firma = negocio?.nombre ? `\n\n${negocio.nombre}` : '';
    let cuerpo;
    switch (o.estado) {
      case 'en_proceso': cuerpo = `Buenas noticias: ${serv} ya está *en proceso* 🔧. Pronto te contamos más.`; break;
      case 'entregado': cuerpo = `¡${serv} ya está *entregado* ✅! Muchas gracias por confiar en nosotros. 💜`; break;
      case 'cancelada': cuerpo = `Te avisamos que ${serv} fue *cancelado*. Cualquier duda, aquí estamos.`; break;
      default: cuerpo = `Recibimos tu solicitud de ${serv} 🙌. Te iremos avisando cómo avanza.`;
    }
    const msg = `${saludo} ${cuerpo}${firma}`;
    const url = tel ? linkWhatsAppA(tel, msg) : `https://api.whatsapp.com/send?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const cambiar = async (o, estado) => {
    try {
      await cambiarEstadoOrden(o.id, estado);
      setOrdenes((prev) => prev.map((x) => x.id === o.id ? { ...x, estado } : x));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const borrar = async (o) => {
    if (!window.confirm(`¿Eliminar la orden ${o.numero || ''}? No se puede deshacer.`)) return;
    try {
      await eliminarOrden(o.id);
      mostrarToast('Orden eliminada 🗑️', 'exito');
      setOrdenes((prev) => prev.filter((x) => x.id !== o.id));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const fecha = (f) => f ? new Date(f + 'T00:00:00').toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' }) : '';
  const lista = (ordenes || []).filter((o) => !filtro || o.estado === filtro);

  return (
    <div className="k-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 className="k-page-title">📋 Órdenes de servicio</h2>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => setForm({})} style={{ padding: '10px 18px', background: P, color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Nueva orden</button>
          <button onClick={onVolver} className="k-btn-soft">← Volver</button>
        </div>
      </div>

      {ordenes && ordenes.length > 0 && (
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '16px' }}>
          <button onClick={() => setFiltro('')} style={chip(filtro === '')}>Todas</button>
          {ESTADOS_ORDEN.map((e) => (
            <button key={e.clave} onClick={() => setFiltro(e.clave)} style={chip(filtro === e.clave)}>{e.nombre}</button>
          ))}
        </div>
      )}

      {!ordenes && !error && <div style={{ textAlign: 'center', padding: '32px', color: '#6B7280' }}>⏳ Cargando…</div>}
      {error && <p style={{ textAlign: 'center', padding: '24px', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}

      {ordenes && ordenes.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 16px', color: '#6B7280' }}>
          <div style={{ fontSize: '46px' }}>📋</div>
          <p style={{ fontWeight: 700, color: '#111827', margin: '8px 0 4px' }}>Aún no tienes órdenes</p>
          <p style={{ fontSize: '14px', margin: '0 0 16px' }}>Crea una orden para dar seguimiento a un servicio y guardar sus evidencias.</p>
          <button onClick={() => setForm({})} style={{ padding: '12px 22px', background: P, color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Crear mi primera orden</button>
        </div>
      )}

      {lista.length > 0 && (
        <div style={{ display: 'grid', gap: '10px' }}>
          {lista.map((o) => {
            const est = estadoOrdenInfo(o.estado);
            const nEvid = Array.isArray(o.evidencias) ? o.evidencias.length : 0;
            return (
              <div key={o.id} className="k-card" style={{ padding: '14px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <strong style={{ color: '#111827' }}>{o.numero || 'Orden'}</strong>
                    <span style={{ fontSize: '11.5px', fontWeight: 700, color: est.color, background: est.bg, padding: '2px 9px', borderRadius: '999px' }}>{est.emoji} {est.nombre}</span>
                  </div>
                  <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#6B7280' }}>
                    {o.cliente_nombre || 'Sin cliente'}{o.servicio_nombre ? ` · ${o.servicio_nombre}` : ''}
                  </p>
                  <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#9CA3AF' }}>
                    {o.fecha_entrega ? `Entrega: ${fecha(o.fecha_entrega)}` : ''}{nEvid > 0 ? `${o.fecha_entrega ? ' · ' : ''}📷 ${nEvid}` : ''}
                  </p>
                </div>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', width: '100%', justifyContent: 'flex-end', borderTop: '1px solid #F3F4F6', paddingTop: '8px' }}>
                  <select value={o.estado} onChange={(e) => cambiar(o, e.target.value)}
                    style={{ padding: '5px 8px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '12px', background: '#fff' }}>
                    {ESTADOS_ORDEN.map((e) => <option key={e.clave} value={e.clave}>{e.nombre}</option>)}
                  </select>
                  <button onClick={() => avisar(o)} style={{ padding: '5px 12px', background: '#DCFCE7', color: '#166534', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>📲 Avisar</button>
                  <button onClick={() => setForm({ orden: o })} style={{ padding: '5px 12px', background: '#EEF2FF', color: '#4338CA', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>✏️ Abrir</button>
                  {!esVendedora && <button onClick={() => borrar(o)} style={{ padding: '5px 10px', background: 'none', border: '1px solid #FCA5A5', borderRadius: '6px', fontSize: '12px', color: '#DC2626', cursor: 'pointer' }}>🗑️</button>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {form && (
        <OrdenForm orden={form.orden || null} onCerrar={() => setForm(null)} onGuardado={cargar} />
      )}
    </div>
  );
}

function chip(activo) {
  return {
    padding: '5px 12px', borderRadius: '999px', fontSize: '12.5px', fontWeight: 600, cursor: 'pointer',
    border: activo ? `1px solid ${P}` : '1px solid #E5E7EB',
    background: activo ? 'color-mix(in srgb, var(--color-primario,#DB2777) 10%, white)' : '#fff',
    color: activo ? P : '#6B7280',
  };
}
